module.exports = __webpack_public_path__ + "img/Game_target_Z-24.5a5dd729.png";